import { CleaningMission } from '@silbo/core';
import { TFunction } from 'i18next';
import { createElement } from 'react';
import { toast } from 'sonner';
import RewardToast from '../components/RewardToast';

const CONGRATULATIONS = [
  'celebration.finished.0',
  'celebration.finished.1',
  'celebration.finished.2',
  'celebration.finished.3',
  'celebration.finished.4',
] as const;

const DURATION = 4000;
const BOTTOM_OFFSET = 88;

let lastIndex = -1;

/** Jamais deux fois le même message d'affilée : sinon la rotation passe inaperçue. */
const nextIndex = (): number => {
  const index = (lastIndex + 1 + Math.floor(Math.random() * (CONGRATULATIONS.length - 1))) % CONGRATULATIONS.length;
  lastIndex = index;
  return index;
};

export const congratulate = (t: TFunction<'environmental-cleaning'>, mission: CleaningMission): void => {
  const key = CONGRATULATIONS[nextIndex()];
  const values = { room: mission.bed.parent?.name ?? mission.bed.name, bed: mission.bed.name };
  toast.custom(
    (id) =>
      createElement(RewardToast, {
        title: t(`${key}.title`, values),
        message: t(`${key}.message`, values),
        onClose: () => toast.dismiss(id),
      }),
    { duration: DURATION, style: { bottom: BOTTOM_OFFSET } }
  );
};
